<template>

  <v-container fluid grid-list-lg mb-3>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>

        <h2 class="heading-2 align-left">Personal Information</h2>

        <v-alert  :value="true"  v-if="error != null" type="error" >{{ error.message }}</v-alert>
        <v-alert  :value="true"  v-if="success != null" type="success" >{{ success.message }}</v-alert>

        <v-layout justify-center column>
          <template v-if="ready">
            <v-form ref="form" v-model="valid" lazy-validation @submit="updateUser">
             
              <v-layout row>
                <v-flex xs12>
                  <v-text-field outline v-model="firstName" :rules="firstNameRules" label="First name *" required ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-text-field outline v-model="lastName" :rules="lastNameRules" label="Last name *" required ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs12>
                  <v-text-field outline v-model="username" :rules="usernameRules" readonly label="Email *" required ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs3 pb-0>
                  <v-select
                    :hide-details="true"
                    label="Phone country*"
                    :items="countries"
                    item-value="code"
                    v-model="phoneCountry"
                    outline
                    required
                  >
                    <template slot="selection" slot-scope="data">
                      <!-- HTML that describe how select should render selected items -->
                      +{{ data.item.phoneCode }}
                    </template>
                    <template slot="item" slot-scope="data">
                      <!-- HTML that describe how select should render items when the select is open -->
                      {{ data.item.name }} (+{{
                        data.item.phoneCode
                      }})
                    </template>
                  </v-select>
  
                </v-flex>
                <v-flex xs9>
                  <v-text-field
                    outline
                    v-model="phoneNumber"
                    :rules="phoneRules"
                    label="Mobile phone number*"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs12 sm3>Date of birth*</v-flex>
                <v-flex xs12 sm3>
                  <v-select
                    :items="days"
                    label="DD*"
                    v-model="dobDay"
                    :rules="dobRules"
                    required
                    readonly
                    outline
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm3 >
                  <v-select
                    :items="months"
                    label="MM*"
                    v-model="dobMonth"
                     :rules="dobRules"
                    outline
                    readonly
                    required
                  ></v-select>
                  </v-flex>
                <v-flex xs12 sm3>
                  <v-select
                    :items="years"
                    label="YYYY*"
                    v-model="dobYear"
                     :rules="dobRules"
                    outline
                    readonly
                    required
                  ></v-select>
                </v-flex>
              </v-layout>

              <v-layout row align-center mx-1>
                <v-spacer />
                <button type="submit" class="button" :disabled="!valid || !ready" color="success" >Save details</button>
              </v-layout>

            </v-form>
          </template>

          <template v-else>
            <div class="text-xs-center">
              <v-progress-circular
                :size="50"
                color="accent"
                indeterminate
              ></v-progress-circular>
            </div>
          </template>
        </v-layout>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import { parsePhoneNumber } from 'awesome-phonenumber'
export default {
  name: 'UserProfile',
  data () {
    
    return {
      ready: false,
      valid: true,
      firstNameRules: [
        v => !!v || 'First name is required'
      ],
      lastNameRules: [
        v => !!v || 'Last name is required'
      ],
      usernameRules: [
        v => !!v || 'Email address is required',
        v => /.+@.+/.test(v) || 'Email must be valid',
        v => (!v.includes(' ')) || 'An email address can not contain any spaces'
      ],
      dobRules: [
        v => !!v || 'Date of Birth is required'
      ],
      ssoid: '',
      firstName: '',
      lastName: '',
      phoneNumber: "",
      phoneCountry: "",
      phoneNormalised: "",
      username: '',
      country: "",
      countries: [],
      dobDay: null,
      dobMonth: null,
      dobYear: null,
      originalEmail: '',
      error: null,
      success: null,
      loading: false,
      days: [],
      months: [],
      years: []
    }
  },
  created () {
    // load this user's latest information
    this.$getCurrentUserAttributes().subscribe((userData) => {
      // console.log(userData)
      console.log('getting user attributes')
      this.ssoid = userData['sub']
      this.username = userData.email
      this.firstName = userData.given_name
      this.lastName = userData.family_name
      this.phoneNumber = userData.phone_number;
      this.originalEmail = userData.email

      const pn = parsePhoneNumber(userData.phone_number);
       // console.log("PHONE Number pasring", userData.phone_number,pn);
        if (pn.valid) {
          this.phoneNumber = pn.number.national;
          this.phoneCountry = pn.regionCode;
         // console.log("PHONE Number set", this.phoneNumber, this.phoneCountry);
        }

      if(userData.birthdate){
        var birthdayDates = userData.birthdate.split('-')
        this.dobDay = parseInt(birthdayDates[2])
        this.dobMonth = parseInt(birthdayDates[1])
        this.dobYear = parseInt(birthdayDates[0])
      }

      fetch("/countries.json")
          .then((r) => r.json())
          .then(
            (json) => {
              this.countries = json.countries;
            },
            (response) => {
              console.log("Error loading json:", response);
            }
          );
      // tell the app that we've finished loading
      this.ready = true
    }, 
    (err)=> {
        console.log('Unable to load user profile, session may not be present.')
    });
    
  },
  computed: {
    phoneRules() {
      //alert(this.phoneNumber)
      const pn = parsePhoneNumber( this.phoneNumber , { regionCode: this.phoneCountry});
      //console.log(pn)
      console.log('Phone number is', pn.valid)
      if (!this.phoneNumber) {
        console.log('Phone number Doesn\'t exist')
        return ["Phone number is required"];
        
      } else {
        console.log('Phone number exists')
        return [() => pn.valid|| "Please ensure you have selected your phone country and entered the number correctly"];
      }
    }
  },
  mounted (){
    this.populateDates()
  },
  methods: {
    pad (num, size) {
      var s = num+"";
      while (s.length < size) s = "0" + s;
      return s;
    },
    populateDates () {
      console.log('ADDING DATES')
      for(var d=1; d<32; d++){
        this.days.push(d)
      }
      for(var m=1; m<13; m++){
        this.months.push(m)
      }
      var thisYear = new Date().getFullYear()
      for(var y=thisYear+1; y > 1900 ; y--) {
        this.years.push(y)
      }
    },
    crmXCMPush(username){
      var crmXCMPushURL = process.env.VUE_APP_XCM_CRM_API+'/user/push/'+ username
      console.log('XCM push url', crmXCMPushURL)
      return axios({
        method: 'get',
        url: crmXCMPushURL
      })
    },
    complete(username){
      console.log('completing')
      var vm = this
      this.dataPush(username)
      .then(function (results) {
        vm.error = null
        var response = {"message": 'Your details have been updated successfully.'}
        vm.success = response
        vm.ready = true

        vm.$getSession().subscribe(
        sessionData => {
          console.log("Session data", sessionData);
          // Post Data to SeatGeek's server (using the id Token)
          setTimeout(function() {
            var lastSub = vm.$cookie.get(
              `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser`
            );
            var idToken = vm.$cookie.get(
              `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.idToken`
            );
            axios
              .post(`${process.env.VUE_APP_SEATGEEK_SRO_ENDPOINT}`, idToken)
              .then(function(seatGeekResponse) {
                // Tell our parent window that the profile has been updated (if one exists)
                if (window.opener) {
                  console.log("sending profileUpdated postMessage");
                  window.opener.postMessage("profileUpdated", "*");
                }
                vm.redirectUser();
              })
              .catch(function(error) {
                // Tell our parent window that the profile has been updated (if one exists)
                if (window.opener) {
                  console.log("sending profileUpdated postMessage");
                  window.opener.postMessage("profileUpdated", "*");
                }
                vm.redirectUser();
              });
          }, 500);
        });
      });
    },
    updateUser (e) {
        e.preventDefault()
        this.ready = false
        
        var email = this.username
        var firstName = this.firstName
        var lastName = this.lastName

        var attributesList = {
          "given_name": firstName, 
          "family_name": lastName,
        }

        const pn = parsePhoneNumber( this.phoneNumber , { regionCode: this.phoneCountry});
        if(pn.valid === true){
          attributesList['phone_number'] = pn.number.e164
          console.log('Saving phone', attributesList['phone_number'])
        }

        if(this.dobDay && this.dobMonth && this.dobYear){
          attributesList['birthdate'] = this.dobYear + '-' + this.pad(this.dobMonth, 2) + '-' + this.pad(this.dobDay, 2)
        }

        if(this.originalEmail.toLowerCase() != email.toLowerCase()){
          attributesList['email'] = email
          // trigger verification workflow
        }
        var vm = this
        this.$updateAttributes(attributesList).subscribe((response) => {
          console.log("update successful")
          vm.complete(this.ssoid)  
        }, 
        (err)=> {
          //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
          // console.log(err.message)
          this.success = null
          this.error = err
          this.ready = true
        });       
    }
  }
}
</script>

<style scoped>
</style>